import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link } from 'react-router-dom'
import Sidebar_component from './Sidebar_component'

export default function Create() {

    const [permissions, setPermissions] = useState([]);
    const [sidebarOpen, setSidebarOpen] = useState(false);

    useEffect(() => {
        const storedPermissions = JSON.parse(localStorage.getItem('user_permissions')) || [];
        setPermissions(storedPermissions);
    }, []);

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />

            <div className='vl_dsh_bodypart'>
                <section className='vl_dsh_bodypart_section'></section>

                <div className='vl_dsh_create_buttons'>
                    <h2>What You Want To Create</h2>

                    <div className='all_links_create'>

                        {permissions.includes("project.manage") && (
                            <Link to='/create_projects'>Create Project</Link>
                        )}

                        {permissions.includes("task.manage") && (
                            <Link to='/create_task'>Create Task</Link>
                        )}

                        {permissions.includes("task.create") && (
                            <Link to='/member_create_task'>Create Task</Link>
                        )}

                        {permissions.includes("user.manage") && (
                            <Link to='/add_member'>Create Team</Link>
                        )}

                        {/* 
{permissions.includes("portfolio.create") && (
    <a 
        href={`create_portfolio.php?comid=${localStorage.getItem('mem_company_id')}`}
        target="_blank"
        rel="noopener noreferrer"
    >
        Create Portfolio
    </a>
)}
*/}
                    </div>

                    <div className='all_links_create'>

                        {permissions.includes("goal.create") && (
                            <Link to='/create_goal'>Create Goal</Link>
                        )}

                        {permissions.includes("notification.create") && (
                            <Link to='/notification'>Create Notifications</Link>
                        )}

                        {permissions.includes("role.manage") && (
                            <Link to='/role_permission'>Role & Permission</Link>
                        )}

                        {permissions.includes("invitation.create") && (
                            <Link to='/communications'>Communications</Link>
                        )}

                    </div>

                    <p>
                        Click the 'Create' button for the item you want to create.
                        This will take you to the relevant page where you can proceed.
                    </p>

                </div>
            </div>
        </div>
    )
}